/**
 * Returns Dynamic Generated Classes
 */

function HowToChildPositionClasses(attributes) {
	const sourceClass = 'wpsp-howto-child-has-image';
	let iconimgStyleclass = '';

	iconimgStyleclass += 'wpsp-howto-child' + ' ';
	iconimgStyleclass += sourceClass + ' ';
	iconimgStyleclass +=
		'wpsp-howto-child-icon-' + attributes.iconimgPosition + ' ';

	if (attributes.enableBorder) {
		iconimgStyleclass += 'wpsp-howto-child-enable-border' + ' ';
	}

	iconimgStyleclass += 'wpsp-howto-child-enable-border-radius' + ' ';

	return [iconimgStyleclass];
}

export default HowToChildPositionClasses;
